import { Persistor } from 'redux-persist/es/types'

import { createContext, useContext } from 'react'

export const PersistorContext = createContext<Persistor | null>(null)

export const usePersistor = () => {
  const context = useContext(PersistorContext)
  if (!context) {
    throw new Error('usePersistor must be used within a PersistorProvider')
  }
  return context
}
